import { Option } from './multi-combobox';

export const filterOptions = (
  options: Option[],
  selectedItems: Option[],
  inputValue: string
) => {
  const isUnselectedAndMatching = (option: Option) => {
    const isAlreadySelected = selectedItems.some(
      (item) => item.value === option.value
    );

    const matchesTheInput =
      option.value.toLowerCase().includes(inputValue.toLowerCase()) ||
      option.label.toLowerCase().includes(inputValue.toLowerCase());

    return !isAlreadySelected && matchesTheInput;
  };

  return options.filter(isUnselectedAndMatching);
};
